export function ChevronLeft(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.8258 19.4229c.3741-.3744.5841-.882.5841-1.4112 0-.5293-.21-1.0367-.5841-1.411l-6.09972-6.102c-.1247-.1249-.19482-.2942-.19482-.4706s.07012-.34559.19482-.4704l6.09972-6.09971c.1962-.18282.3535-.40322.4628-.64819.1091-.24496.1677-.50948.1725-.77763.0046-.26815-.0445-.5344-.1451-.78305-.1004-.24867-.2498-.474661-.4396-.664287-.1895-.189649-.4154-.339047-.6642-.439474-.2486-.1004269-.5149-.14977518-.783-.14504894-.2682.00472624-.5325.06339314-.7777.17253994-.2449.109148-.4653.266557-.6481.462751L5.90143 6.73748c-.87269.87369-1.36284 2.05823-1.36284 3.29302 0 1.2348.49015 2.4191 1.36284 3.2929l6.10197 6.1019c.3772.3688.884.5751 1.4115.5747.5278-.0004 1.0342-.2077 1.4109-.5771Z"
      />
    </svg>
  );
}
